import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { isNumber, toInteger, padNumber } from '../../trackvision/util/util';
@Injectable({
  providedIn: 'root'
})
export class DateformatService extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
			if (value) {
				const dateParts = value.trim().split('/');
				if (dateParts.length === 1 && isNumber(dateParts[0])) {
					return {day: toInteger(dateParts[0]), month: null, year: null};
				} else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
					return {day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: null};
				} else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
					return {day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2])};
				}
			}
			return null;
		}
		format(date: NgbDateStruct): string {
			return date ?
					`${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}` :
					'';
		}

	formatISODate(dateString: string) {
		let date = new Date(dateString)
		return ("0" + date.getDate()).slice(-2) + '-'
			+ ("0" + (date.getMonth() + 1)).slice(-2) + '-'
			+ date.getFullYear();
	}
}
